exports.linkResolver = (doc) => {
  if (doc.uid !== 'index' && doc.type === 'page') return `/${doc.uid}/`
  if (doc.type === 'case_study') return `/case-studies/${doc.uid}/`
  if (doc.type === 'blogpost') return `/news/${doc.uid}/`
  return `/`
}
